import { Fragment, useState, useEffect } from 'react';
import classes from './category-selector.module.css';

interface Category {
  id: number;
  name: string;
  description: string;
}

interface CategorySelectorProps {
  categories: Category[];
  selectedCategoryIds: number[];
  onChange: (selectedIds: number[]) => void;
}

const CategorySelector: React.FC<CategorySelectorProps> = (props) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCategories, setFilteredCategories] = useState<Category[]>(props.categories);

  useEffect(() => {
    const filtered = props.categories.filter((category) =>
      category.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredCategories(filtered);
  }, [searchTerm, props.categories]);

  const handleToggleCategory = (categoryId: number) => {
    const isSelected = props.selectedCategoryIds.includes(categoryId);
    let newSelectedIds: number[];

    if (isSelected) {
      newSelectedIds = props.selectedCategoryIds.filter((id) => id !== categoryId);
    } else {
      newSelectedIds = [...props.selectedCategoryIds, categoryId];
    }

    props.onChange(newSelectedIds);
  };

  const selectedCategories = props.categories.filter(cat => props.selectedCategoryIds.includes(cat.id));

  return (
    <Fragment>
      <div className={classes['label-wrapper']}>
        <label htmlFor="category-search">Favorite Categories</label>
      </div>
      <div className={classes.container}>
        {selectedCategories.length > 0 && (
          <div className={classes.selectedContainer}>
            {selectedCategories.map((category) => (
              <div
                key={category.id}
                className={classes.selectedChip}
                onClick={() => handleToggleCategory(category.id)}
              >
                {category.name}
                <span className={classes.removeIcon}>×</span>
              </div>
            ))}
          </div>
        )}

        <input
          type="text"
          id="category-search"
          className={classes.searchBox}
          placeholder="Search categories..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div className={classes.categoryList}>
          {filteredCategories.length === 0 ? (
            <div className={classes.noResults}>No categories found</div>
          ) : (
            filteredCategories.map((category) => {
              const isSelected = props.selectedCategoryIds.includes(category.id);
              return (
                <div
                  key={category.id}
                  className={`${classes.categoryItem} ${isSelected ? classes.selected : ''}`}
                  onClick={() => handleToggleCategory(category.id)}
                >
                  <div className={classes.categoryName}>{category.name}</div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default CategorySelector;

